import {OverlayState} from "@/hooks/common/useOverlay";
import * as style from "@COMPONENTS/style/detailpackage/productpopup";
import {GuideSlideImg} from "@COMPONENTS/style/slide";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {PopupContainer} from "@FRAMEWORK/ui/desktop/popup";
import {GuideSlide} from "@FRAMEWORK/ui/desktop/slide";
import {TableContainer} from "@FRAMEWORK/ui/desktop/table";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import useEventInfoImages from "@QUERIES/prdt/event/useEventInfoImages";
import {EventTourDetail} from "@QUERIES/prdt/event/useEventTourDetail";
import {Noimage} from "@yb/ui/desktop/common/Noimage";
import {useEffect, useState} from "react";
import {SwiperSlide} from "swiper/react";

export interface TravelInfo extends OverlayState {
	trv: Partial<EventTourDetail>;
}

type TourDetailType = {
	title: string;
	content: string;
	addrOne: string;
	cautionTip: string;
	entFee: string;
	faxNo: string;
	homepageUrl: string;
	korNm: string;
	locNm: string;
	mapTrans: string;
	operHour: string;
	telNo: string;
	tourDestId: string;
	layersGuestRoom: string;
	chkInOut: string;
	addFacilities: string;
	priceInfo: string;
};

const label = {
	10: "도시",
	20: "숙소",
	30: "관광지",
	40: "먹거리",
	50: "즐길거리",
	60: "쇼핑",
	70: "선택관광",
	80: "골프",
};

const path = {
	10: "", // 도시
	20: "/residence", // 숙소
	30: "/itnr-info", // 관광지
	40: "/itnr-info", // 먹거리
	50: "/itnr-info", // 즐길거리
	60: "/itnr-info", // 쇼핑
	70: "/itnr-info", // 선택관광
	80: "/golf", // 골프
};

const TravelInfoPopup = (props: TravelInfo) => {
	const [tourDetail, setTourDetail] = useState<TourDetailType>(null);
	const {trv, ...overlayProps} = props;
	const {trvCd, trvInfoId} = trv;

	const imageFetch = useEventInfoImages(trvInfoId);
	const tourImage = imageFetch.data?.body || [];

	const asyncTourDescriptionFetch = async () => {
		const res = await useConfigureAxios({
			url: `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-info/${trvInfoId}${path[trvCd]}`,
		});
		setTourDetail(res.data?.body);
	};

	useEffect(() => {
		if (tourDetail) return;
		path[trvCd] && asyncTourDescriptionFetch();
	}, []);

	return (
		<PopupContainer {...overlayProps} size="regular" title={label[trvCd]}>
			<style.SubTitle>
				{tourDetail?.korNm} {tourDetail?.locNm && `(${tourDetail.locNm})`}
			</style.SubTitle>
			{tourImage.length > 0 && (
				<style.SlideWrap>
					<GuideSlide perView={2} spaceBetween={12}>
						{tourImage.map(ti => (
							<SwiperSlide key={ti.imageThum2 + String(ti.sortOrder)}>
								<GuideSlideImg>
									<Noimage width="354px" height="240px" src={ti.imageThum2} alt="" />
								</GuideSlideImg>
							</SwiperSlide>
						))}
					</GuideSlide>
				</style.SlideWrap>
			)}

			{tourDetail?.content && <style.InfoText dangerouslySetInnerHTML={{__html: tourDetail.content}} />}
			<TableContainer line={false}>
				<caption>관광지 정보</caption>
				<colgroup>
					<col style={{width: 120}} />
					<col style={{width: 240}} />
					<col style={{width: 120}} />
					<col style={{width: 240}} />
				</colgroup>
				<tbody>
					{tourDetail?.addrOne && (
						<tr>
							<th scope="row">주소</th>
							<td colSpan={3}>{tourDetail.addrOne}</td>
						</tr>
					)}
					{(tourDetail?.telNo || tourDetail?.faxNo) && (
						<tr>
							<th scope="row">전화</th>
							<td>{tourDetail?.telNo}</td>
							<th scope="row">팩스</th>
							<td>{tourDetail?.faxNo}</td>
						</tr>
					)}
					{tourDetail?.homepageUrl && (
						<tr>
							<th scope="row">홈페이지</th>
							<td colSpan={3}>
								<a href={tourDetail.homepageUrl}>{tourDetail.homepageUrl}</a>
							</td>
						</tr>
					)}
					{tourDetail?.operHour && (
						<tr>
							<th scope="row">운영시간</th>
							<td colSpan={3}>{tourDetail.operHour}</td>
						</tr>
					)}
					{tourDetail?.priceInfo && (
						<tr>
							<th scope="row">입장료</th>
							<td colSpan={3}>{tourDetail.priceInfo}</td>
						</tr>
					)}
					{tourDetail?.mapTrans && (
						<tr>
							<th scope="row">교통편</th>
							<td colSpan={3}>{tourDetail.mapTrans}</td>
						</tr>
					)}
					{tourDetail?.addFacilities && (
						<tr>
							<th scope="row">부대시설</th>
							<td colSpan={3}>{tourDetail.addFacilities}</td>
						</tr>
					)}
					{tourDetail?.cautionTip && (
						<tr>
							<th scope="row">참고사항</th>
							<td colSpan={3}>{tourDetail.cautionTip}</td>
						</tr>
					)}
				</tbody>
			</TableContainer>
		</PopupContainer>
	);
};

export default TravelInfoPopup;
